import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BusyCursor {
  count: number;

  constructor() {
    this.count = 0;
  }

  incrementCount(): void {
    setTimeout(() => {
      this.count++;
    });
  }

  decrementCount(): void {
    setTimeout(() => {
      if (this.count == 0) return;

      if (this.count < 0) {
        this.count = 0;
        return;
      }

      this.count--;
    });
  }

  resetCount(): void {
    setTimeout(() => {
      this.count = 0;
    });
  }
}